/* global chartLanguage, revisedHTML, bocAmchart */

/**
 * Function to set up the 'revised' text suffix
 *
 * @returns {string} text to use for balloon if data was revised
 */
bocAmchart.getRevisedText = function () {
    var revisedText;
    if (typeof(revisedHTML) === 'undefined') {
        revisedText = "<b>(revised)</b> ";
        if (chartLanguage === "fr") {
            revisedText = "<b>(révisé)</b> ";
        }
    } else {
        revisedText = revisedHTML;
    }
    return revisedText;
};

/**
 * Looks up the terms based on the data contained in series label
 *
 * @param {object} data Object containing the valet data sets
 * @param {string} term0 Category term (label for series of columns)
 * @param {string} term1 Series term (label for same color columns, in the legend)
 * @param {object} bocSettings array of bocSettings possibly containing terms in form:
 *                                      {'category':{'EPB':'Excess Bonds'}} to expansion
 * @returns {array} output array of data
 */
bocAmchart.termsPolyfill = function (data, term0, term1, bocSettings) {
    var terms,
        termsLookup,
        lookupTerm0 = false,
        lookupTerm1 = false;

    if (typeof bocSettings.terms === 'object' && typeof bocSettings.terms[chartLanguage] === 'object') {
        termsLookup = bocSettings.terms[chartLanguage];
        if (termsLookup.hasOwnProperty(term0)) {
            lookupTerm0 = true;
        }
        if (termsLookup.hasOwnProperty(term1)) {
            lookupTerm1 = true;
        }
    }

    for (var series in data.seriesDetail) {
        if (data.seriesDetail.hasOwnProperty(series)) {

            if (typeof data.seriesDetail[series].terms !== 'object') {

                // Assuming the label will contain EBPUS_3month type of data,
                // where first is category term id and second is series term id
                terms = data.seriesDetail[series].label.split('_');
                data.seriesDetail[series].terms = {};

                // Define the terms from terms provided or use just ids found from split
                if (lookupTerm0 && termsLookup[term0].hasOwnProperty(terms[0])) {
                    data.seriesDetail[series].terms[term0] = termsLookup[term0][terms[0]];
                } else {
                    data.seriesDetail[series].terms[term0] = terms[0];
                    // Add space after numbers to prevent bad sorting when combining numbers and text
                    // Not using for text labels to prevent breaking existing text category guides
                    if (!isNaN(terms[0])) {
                        data.seriesDetail[series].terms[term0] += " ";
                    }
                }

                // Define the terms from terms provided or use just ids found from split
                if (lookupTerm1 && termsLookup[term1].hasOwnProperty(terms[1])) {
                    data.seriesDetail[series].terms[term1] = termsLookup[term1][terms[1]];
                } else {
                    data.seriesDetail[series].terms[term1] = terms[1];
                }

                if (typeof terms[2] !== "undefined") {
                    data.seriesDetail[series].terms['term2'] = terms[2];
                }
                if (typeof terms[3] !== "undefined") {
                    data.seriesDetail[series].terms['term3'] = terms[3];
                }
            }
        }
    }

    return data;
};
